import { Page } from '../../../../components/Page/Page';
import { SubjectGroupTable } from '../../../../components/SubjectGroup/Tables/SubjectGroupTable';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const DeputateSubjectGroupsSubpage = () => {
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <SubjectGroupTable />
    </Page>
  );
};
